export default  {
    accrualPayments(state) {
        return state.accrualPayments;
    },
    payments(state) {
        return state.payments;
    }
}